import { useReducer } from 'react'

const useForceUpdate = () => {
  const [_, forceUpdate] = useReducer(
    (x) => x + 1,
    0,
    () => 0
  )

  return forceUpdate
}

export default useForceUpdate
